// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { getTopCustomersApi } from "../../Service/Api/TopCustomersApi";
import {
  getTopCustomers,
  getErrors,
  getTopCustomersList,
} from "../Reducer/TopCustomersReducer";

// Watchers
function* topCustomersSaga() {
  yield takeEvery("top_customers/getTopCustomers", getAllTopCustomers);
}

// Sagas
function* getAllTopCustomers(action) {
  try {
    const getTopCustomersData = yield call(getTopCustomersApi, action.payload);
	
    if (getTopCustomersData.request.status === 200) {
      yield put(getTopCustomersList(getTopCustomersData));
    } else {
      yield put(getErrors(true));
    }
  } catch (error) {
    yield put(getErrors(error));
  }
}

export default function* rootSaga() {
  yield all([fork(topCustomersSaga)]);
}
